<template>
    <div id="calendar-day"
        :class="{'calendar-day-anon': !showAvailability}"
        :data-page-date-key="pageDateKey"
        :data-start-hour="startHour"
        :data-end-hour="endHour"
    ><!-- :style="calcGridTemplate" -->
        <!-- HEADERS -->
        <!-- <div class="calendar-page-name">{{pageName}}</div> -->

        <div class="calendar-day-time calendar-corner calendar-row-title col-time">
            <span>Ignore</span>
        </div>

        <template v-if="showAvailability">
            <div class="col-bg col-availability"></div>
            <div class="calendar-row-title col-availability"
                title="Availability"
            >
                <span>Availability</span>
            </div>
        </template>

        <template v-if="showMeetings">
            <div class="col-bg col-meeting"></div>
            <div class="calendar-title-meetings calendar-row-title col-meeting"
                title="My Itinerary"
            >
                <span>My Itinerary</span>
            </div>
        </template>
        
        <template v-if="toggles.track0 && (setOfTrackIdsToday.has(0))">
            <div class="col-bg col-notrack"></div>
            <div class="calendar-title-notrack calendar-row-title col-notrack"
                title="Sessions"
            >
                <span>Sessions</span>
            </div>
        </template>

        <template v-for="track in tracksToday">
            <template v-if="toggles[`track${track.id}`]">
                <div :key="`col-track${track.id}`"
                    :class="`col-bg col-track${track.order_weight}  col-trackid${track.id}`"></div>
                <div  :key="`track${track.id}`"
                    :class="`calendar-row-title col-track${track.order_weight} col-trackid${track.id}`"
                    :title="track.name"
                >
                    <span>{{track.name}}</span>
                </div>
            </template>
        </template>

        <div class="calendar-row-yesterday" title="Previous day">
            <span>&nbsp;</span>
        </div>

        <!-- TIMES -->
        <div class="col-bg col-time"></div>
        <div v-for="row in rowList" :key="dateToHourKey(row)"
            class="calendar-day-time"
            :class="`calendar-day-time-${row.getMinutes()}`"
            :style="`grid-row: ${dateToHourKey(row)}`"
            :data-time="row"
        >
            <span>{{asTimeOnly(row)}}</span>
        </div>

        <div class="calendar-row-tomorrow" title="Next day">
            <span>&nbsp;</span>
        </div>

        <!-- SLOTS : GRID -->
        <!-- Loop through the MeetingSlots:
            - If there is a CalendarItem that has that slot, mark it as busy
            - ElseIf the slot is available, create an AvailabilityToggle set to 'On'
            - ...Privates are handled in the _next_ section, looping through privatesForDay

            - Closed slots are not displayed
        --> 
        <template v-for="slot in slotsForDay"> <!-- hasSlotOverlap(slot, itineraryItems) -->
            <!-- Busy could be obscured by a Private or Exclusion on top -->
            <div v-if="isBusyDuringSlot(slot)" 
                :key="slot.id" 
                :style="calcGridForSlot(slot)"
                class="col-slot calendar-day-slot calendar-day-slot-busy calendar-toggle-slot"
                title="Busy"
            >
                <CheckLarge class="calendar-day-slot-busy-icon" />
                <span>Busy</span>
            </div>
            <CalendarToggleSlot v-else-if="slot.available" :key="slot.id"
                :data-start="slot.start_time"
                :data-start-utc="slot.start_time_utc"
                :style="calcGridForSlot(slot)"
                :slot_id="slot.id"
                :is_private="false"
                :title="`Available: ${asTimeOnly(slot.startObj, timezone)} - ${asTimeOnly(slot.endObj, timezone)}`"
                class="col-slot calendar-day-slot"
            />
            <!--
            <div v-else-if="slot.available" :key="slot.id"
                class="col-slot calendar-day-slot"
                :style="calcGridForSlot(slot)"
                title="Available"
            >
                <CalendarToggleSlot  
                    :slot_id="slot.id"
                    :is_private="false"
                    :title="`${asTimeOnly(slot.startObj, timezone)} - ${asTimeOnly(slot.endObj, timezone)}`"
                />
            </div>
            -->
            <!-- <div v-else :key="slot.id"
                class="col-slot calendar-day-slot calendar-day-slot-closed"
                :style="calcGridForSlot(slot)"
                title="Closed"
            >!!!!!!
                &nbsp;
            </div> -->
        </template>

        <!-- SLOTS : CONTENT -->
        <template v-for="item in privatesForDay"><!--  v-if="isPrivate(item)" -->
            <CalendarToggleSlot 
                :key="`slot${item.id}`"
                class="col-slot calendar-day-slot calendar-slot-private"
                :style="calcGridForSlot(item)"
                :slot_id="item.meeting_slot_id"
                :is_private="true"
                :locked="item.locked"
                :title="`Unavailable: ${asTimeOnly(item.startObj, timezone)} - ${asTimeOnly(item.endObj, timezone)}`"
            />
        </template>


        <!-- ITEMS -->
        <template v-for="item in itemsForDay">
            
            <!-- CALENDAR ITEM - Visibles -->
            <CalendarItem v-if="isVisible(item)"
                :key="`calitem-${item.id}`"
                @click="doModal(item)"
                :item="item"
                :timezone="timezone"
                :style="calcGridForItem(item)"
            >
                <CalendarIcon :item="item" :me="me" />
                <div class="calendar-item-body">
                    <div v-if="item.colleagues && item.colleagues.length" 
                        class="meeting-colleague-count">+ {{item.colleagues.length}}</div>

                    <template v-if="isAppointment(item)">
                        <CalendarItemDetailsShort :item="item" />
                        <div class="calendar-item-meta">
                            <CalendarItemTime :item="item" :timezone="timezone" />
                            <CalendarItemLocation :item="item" />
                        </div>
                        <div v-if="item.abstract_text"
                            class="calendar-item-abstract"
                            v-html="item.abstract_text"></div>
                    </template>
                    <template v-else>
                        <CalendarItemDetailsShort :item="item" />
                        <div class="calendar-item-meta">
                            <CalendarItemTime :item="item" :timezone="timezone" />
                            <CalendarItemLocation :item="item" />
                        </div>
                    </template>
                    
                    <!-- Use short details for Meetings, so that meta isn't hidden in short slots -->
                    <!--
                    <CalendarItemDetails v-if="isAppointment(item)" :item="item" />
                    <CalendarItemDetailsShort v-else :item="item" />
                
                    <div class="calendar-item-meta">
                        <CalendarItemTime :item="item" :timezone="timezone" />
                        <CalendarItemLocation :item="item" />
                    </div>
                    -->
                </div>
                
            </CalendarItem>

            <!-- DUPLICATE ENTRY IN ITINERARY FOR TICKETED ITEMS -->
            <CalendarItem v-if="toggles.ticketed && item.appointment_attendees"
                :key="`calitemticket-${item.id}`"
                @click="doModal(item)"
                :item="item"
                :timezone="timezone"
                :style="calcGridForTicketedItem(item)"
                class="calendar-item-ticketed"
            >
                <CalendarIcon :item="item" :me="me" />
                <div class="calendar-item-body">
                    <CalendarItemDetails :item="item" />
                    <div class="calendar-item-meta">
                        <CalendarItemTime :item="item" :timezone="timezone" />
                        <CalendarItemLocation :item="item" />
                    </div>
                </div>
            </CalendarItem>

            <!-- TAIL FOR PINNED ITEMS -->
            <div v-else-if="item.in_schedule && isVisible(item)"
                :key="`calitemticket-${item.id}`"
                class="calendar-day-pinned-tail"
                :class="itemTrackClasses(item)"
                :style="calcGridForPinnedItemTail(item)"
                :title="itemTitle(item, timezone)"
            >
            </div>
            <!--
            <CalendarItem v-else-if="item.in_schedule"
                :key="`calitemticket-${item.id}`"
                @click="doModal(item)"
                :item="item"
                :timezone="timezone"
                class="calendar-item-pinned"
                :style="calcGridForTicketedItem(item)"
            >
                <CalendarIcon :item="item" :me="me" />
                <div class="calendar-item-body">
                    <CalendarItemDetails :item="item" />
                    <div class="calendar-item-meta">
                        <CalendarItemTime :item="item" :timezone="timezone" />
                        <CalendarItemLocation :item="item" />
                    </div>
                </div>
            </CalendarItem>
            -->

        </template><!-- /ITEMS -->


        <div v-if="itemsForDay.length == 0"
            class="calendar-day-empty"
        >
            <span>DAY EMPTY</span>
        </div>

        <!-- Vue HACK to work around restrictions with style tags -->
        <component :is="'style'">
            #calendar-day {
                {{calcGridTemplate}}
            }
        </component>
    </div>
</template>

<script>
import CheckLarge from '@/components/icons/CheckLarge';
import {asTimeOnly, hasOverlap, keyToLocalTime} from '@/utils/DateTime';
// import {itemClasses, itemTitle} from '@/utils/Attributes';
import {itemTrackClasses, itemClasses, itemTitle} from '@/utils/Attributes';

import {FLAGS} from '@/utils/Item';
import {isAppointment, isPrivate, isTrack0, isInItinerary} from '@/utils/Filter';  //, trackKey  , isInSchedule
import {dateToHour, dateToHourKey} from '@/utils/Sort';  // dateToKey, 

import CalendarIcon from "@/views/calendar/CalendarIcon";
import CalendarItem from "@/views/calendar/CalendarItem";
import CalendarItemDetails from "@/views/calendar/CalendarItemDetails";
import CalendarItemDetailsShort from "@/views/calendar/CalendarItemDetailsShort";
import CalendarItemLocation from "@/views/calendar/CalendarItemLocation";
import CalendarItemTime from "@/views/calendar/CalendarItemTime";

import CalendarToggleSlot from './CalendarToggleSlot';

// Default to showing the start month of the event
export default {
    name: "CalendarDay",
    props: {
        items: {
            type: Array,
            required: true,
        },
        itemsByDate: {
            type: Object,
            required: true,
        },
        privatesByDate: {
            type: Object,
            required: true,
        },
        busySlotIds: {
            type: Set,
            required: true,
        },
        itineraryByDate: {
            type: Object,
            required: true,
        },
        pageDate: {
            type: String,
            required: true,
        },
        eventDates: {
            type: Array,
            required: true,
        },
        activeDates: {
            type: Array,
            required: true,
        },
        itineraryDates: {
            type: Array,
            required: true,
        },
        event: {
            type: Object,
            required: true,
        },
        timezone: {
            type: String,
            required: true,
        },
        filters: {
            type: Object,
            required: true,
        },
        toggles: {
            type: Object,
            required: true,
        },
        slots: {
            type: Array,
            required: false,
        },
        tracks: {
            type: Array,
            required: false,
        },
        me: {
            type: Object,
            required: false,
        }
    },
    components: {
        CalendarIcon,
        CalendarItem,
        CalendarItemDetails,
        CalendarItemDetailsShort,
        CalendarItemLocation,
        CalendarItemTime,
        CalendarToggleSlot,
        CheckLarge,
    },
    computed: {
        // pageName() {
        //     return new Intl.DateTimeFormat(navigator.language, {
        //         month: 'long', year: 'numeric',
        //         day: 'numeric', weekday: 'long',
        //     }).format(this.pageDate);
        // },
        pageDateKey() {
            return this.pageDate;
            //return dateToKey(this.pageDate);
        },
        itemsForDay() {
            // let key = dateToKey(this.pageDate);
            // return this.itemsByDate[key] ?? [];
            return this.itemsByDate[this.pageDateKey] ?? [];
        },
        privatesForDay() {
            return this.privatesByDate[this.pageDateKey] ?? [];
        },
        itineraryItems() {
            // ONLY my meetings or appointments
            return this.itemsForDay.filter(item => { return (isInItinerary(item) || isPrivate(item))});
        },
        slotsForDay() {
            if (!this.showAvailability) { return []; }
            return this.slots.filter(slot => (slot.startDateKey == this.pageDateKey));
        },
        shortestSlotMinutes() {
            let shortest = 20; // Threshold for small rows is 15, so start higher than that.
            this.slots.forEach(slot => {
                let diffMS = slot.endObj - slot.startObj;
                let diffMins = parseInt(diffMS/(60*1000));
                if (diffMins < shortest) { shortest = diffMins; }
            });
            return shortest;
        },
        shortestItemMinutes() {
            let shortest = 20; // Threshold for small rows is 15, so start higher than that.
            this.itemsForDay.forEach(item => {
                let diffMS = item.endObj - item.startObj;
                let diffMins = parseInt(diffMS/(60*1000));
                if (diffMins < shortest) { shortest = diffMins; }
            });
            return shortest;
        },
        /* Calculate the earliest/latest hour that should be shown as a row */
        startHour() {
            let start = 23;
            this.itemsForDay.forEach(item => {
                if (this.pageDateKey == item.startDateKey) {
                    let cur = dateToHour(item.startObj, this.timezone);
                    if (cur < start) { 
                        start = cur; 
                    }
                }
                if (this.pageDateKey == item.endDateKey) {
                    let cur = dateToHour(item.endObj, this.timezone);
                    if (cur < start) { start = cur; }
                }
            });
            this.slotsForDay.forEach(item => {
                if (this.pageDateKey == item.startDateKey) {
                    let cur = dateToHour(item.startObj, this.timezone);
                    if (cur < start) { 
                        start = cur; 
                    }
                }
                if (this.pageDateKey == item.endDateKey) {
                    let cur = dateToHour(item.endObj, this.timezone);
                    if (cur < start) { start = cur; }
                }
            });
            return start;
        },
        endHour() {
            let end = 0;
            this.itemsForDay.forEach(item => {
                if (this.pageDateKey == item.startDateKey) {
                    let cur = dateToHour(item.startObj, this.timezone, true);
                    if (cur > end) { end = cur; }
                }
                if (this.pageDateKey == item.endDateKey) {
                    let cur = dateToHour(item.endObj, this.timezone, true);
                    if (cur > end) { end = cur; }
                }
            });
            this.slotsForDay.forEach(item => {
                if (this.pageDateKey == item.startDateKey) {
                    let cur = dateToHour(item.startObj, this.timezone, true);
                    if (cur > end) { end = cur; }
                }
                if (this.pageDateKey == item.endDateKey) {
                    let cur = dateToHour(item.endObj, this.timezone, true);
                    if (cur > end) { end = cur; }
                }
            });
            return end;
        },
        /** As with dateList, generate a set of date objects for each grid row */
        rowList() {
            let rows = [];
            const mins = 5;
            const rowsPerHour = 60/mins;
            // const range = (((this.endHour+1) - this.startHour) * rowsPerHour) + 1; // +1 row so that we see the ending hour
            const range = (((this.endHour) - this.startHour) * rowsPerHour) + 1; // +1 row so that we see the ending hour

            let dateObj = keyToLocalTime(this.pageDate);
            // let dateObj = dateForTimezone(this.pageDate, this.timezone);
            // let curDate = new Date(this.pageDate);
            for (let x=0; x< range; x++) {
                let curDate = new Date(dateObj);
                let curMins = x * mins;
                curDate.setHours(this.startHour);
                curDate.setMinutes(curMins);
                rows.push(curDate);
            }
            return rows;
        },
        /** List of the trackNames present today */
        setOfTrackIdsToday() {
            const out = new Set();
            this.itemsForDay.forEach(item => {
                if (isAppointment(item)) {
                    out.add(item.track_id ?? 0);
                    /*
                    let curTrackId = item.track_id ?? 0;
                    if (! (curTrackId in out)) {
                        out.push(curTrackId);
                    }
                    */
                }
                /*
                let tKey = trackKey(item);
                if (tKey && !(tKey in out)) {
                    out.push(tKey);
                }
                */
            });
            return out;
        },
        tracksToday() {
            return this.tracks.filter(track => this.setOfTrackIdsToday.has(track.id));
            // return this.tracks.filter(track => track.id in this.trackIdsToday);
        },
        showMeetings() {
            return (
                this.filters.confirmed ||
                this.filters.inbound ||
                this.filters.outbound ||
                this.filters.cancelled
            )
        },
        showAvailability() {
            // Only show availability if logged in.
            return (this.me && this.me.id);
        },
        calcGridTemplate() {
            // SEE ALSO: calcColumnForItem()
            // col-time, col-meeting, col-track0, col-trackN...
            const cols = [
                '[col-time] 80px'
            ];
            if (this.showAvailability) { cols.push('[col-slot] 100px'); }
            if (this.showMeetings) { cols.push('[col-meeting] 1fr'); }  // Was 1.5fr
            if (this.toggles.track0 && this.setOfTrackIdsToday.has(0)) { cols.push('[col-notrack] 1fr'); }
            // trackN
            this.tracksToday.forEach(track => {
                // let trackId = `track${track.id}`;
                let trackOrder = `track${track.order_weight}`;
                if (this.toggles[track.trackKey]) {
                    cols.push(`[col-${trackOrder}] 1fr`);
                }
            });

            // row-page, row-title, hourHHMM...
            const rows = [
            //    '[row-page] 20px',
                '[row-title] 20px',
                '[row-yesterday] 20px',
                '[row-null] 10px', // Spacer for span offset
            ];

            // Adjust row height based on slot duration
            // let rowHeight = 7;
            // if (this.shortestSlotMinutes <= 15) {
            //     rowHeight = 10;
            // }
            // AvailabilitySwitch is 16px high. It should _nearly_ always display cleanly
            // If rowHeightPx = 10, a 15min slot is 30px high
            let rowHeightPx = 10;
            if (this.shortestItemMinutes == 15) { rowHeightPx = 12; } // 15min slot would be 36px high
            if (this.shortestItemMinutes < 15) { rowHeightPx = 15; } // 10min slot would be 30px high
            if (this.shortestItemMinutes < 10) { rowHeightPx = 20; } //  5min slot would be 20px high

            this.rowList.forEach(row => {
                rows.push(`[${dateToHourKey(row)}] ${rowHeightPx}px`); // Was 20px
            });
            rows.push(`[row-tomorrow] 20px`);
            rows.push(`[row-last] 1px`);

            return `grid-template-columns: ${cols.join(' ')}; ` +
                ` grid-template-rows: ${rows.join(' ')}; `;
        }
    },
    methods: {
        asTimeOnly,
        dateToHourKey,
        itemClasses,
        itemTitle,
        itemTrackClasses,
        doModal(item) {
            this.$emit('modal', {
                item: item,
                items: this.itemsForDay
            });
        },
        isAppointment,
        isPrivate,
        // Custom check for ticketed items that should still be shown if their track is toggled off
        isVisible(item) {
            // Meetings already in Itinerary, should always be shown if already in items :-)
            if (isPrivate(item)) { return false; }
            // if (!isAppointment(item)) {
            //     return true;
            // }
            if (isAppointment(item)) {
                // console.log("isVisble:", item.id, item.trackKey);
                return this.toggles[item.trackKey];
            }
            return true;
            
            // let trackName = "track0";
            // if (item.track_id) {
            //     trackName = `track${item.track_id}`;
            // }
            // return this.filters.toggle[trackName];
        },
        // Check if there is a private/meeting or *appointment* during this slot
        isBusyDuringSlot(slot) {
            // console.log("isBusyDuringSlot")
            if (this.busySlotIds.has(slot.id)) { return true; }

            for (let item of this.filters.ticketed) {
                if (hasOverlap(slot, item)) { return true; }
            }
            return false
        },
        /*
        hasSlotOverlap(slot, items) {
            // TODO: Add appointment logic :-/
            let found = items.findIndex(item => item.meeting_slot_id == slot.id) >= 0;
            if (found) return true;

            // items.forEach(item => {
            for (let item of items) {
                // if (found) { continue; }
                if (isAppointment(item)) {
                    if (hasOverlap(slot, item)) {
                        return true;
                    }
                }
            }
            return false;
            // let indx = items.findIndex(item => item.meeting_slot_id == slot.id);
            // let found = indx >= 0;
            // console.log("hasSlogOverlap:", slot, items, found)
            // return found;
        }, */
        calcColumnForItem(item) {
            if (isAppointment(item)) {
                let hasTicket = '';
                if (isTrack0(item)) {
                    return `${hasTicket}col-notrack`;
                } else {
                    return `${hasTicket}col-track${item.track_order}`;
                }
            } else {
                return "col-meeting";
            }
        },
        calcRowsForItem(item) {
            // Catch items that start/end on another day
            let start = '';
            let end = '';
            
            if (item.startDateKey != this.pageDateKey) {
                start = 'row-yesterday';
            } else {
                start = dateToHourKey(item.startObj, this.timezone);
            }

            if (item.endDateKey > this.pageDateKey) {
                end = 'row-last';
            } else {
                end = dateToHourKey(item.endObj, this.timezone);
            }
            return `${start} / ${end}`;
        },
        calcGridForItem(item) {
            // Generate CSS position to inject into :style=""
            if (item.flags.includes(FLAGS.TRACK_HIDDEN)) {
                return `grid-row: ${this.calcRowsForItem(item)}; grid-column: col-meeting;`;
            }
            return `grid-row: ${this.calcRowsForItem(item)}; grid-column: ${this.calcColumnForItem(item)};`;
        },
        calcGridForTicketedItem(item) {
            return `grid-row: ${this.calcRowsForItem(item)}; grid-column: col-meeting;`;
        },
        calcGridForPinnedItemTail(item) {
            return `grid-row: ${this.calcRowsForItem(item)}; grid-column: col-meeting / -1;`;  // 2 // col-meeting / -1;
        },
        calcGridForSlot(slot) {
            // May be passed a meeting_slot OR a meeting
            // Generate CSS position to inject into :style=""
            let col = 'col-slot';
            if (isPrivate(slot)) {
                // col = 'col-slot / span 2';
            }
            return `grid-row: ${this.calcRowsForItem(slot)}; grid-column: ${col};`;
        },
    },
}
</script>

<style>
#calendar-day {
  display: grid;
  width: 100%;
  background: var(--col-calendar-bg); /* #ccc; #fff; */
  gap: 0 1px;
}

.calendar-day-time {
    grid-column: col-time;
    border-bottom: none;
    background: none;
    position: relative;
}
.calendar-day-time-0 {
    border-top: 1px solid #999;
}
.calendar-day-time-15,
.calendar-day-time-30,
.calendar-day-time-45 {
    border-top: 1px solid #ccc;
}
.calendar-day-time span {
    visibility: hidden;
}
.calendar-day-time-0 span {
    visibility: visible;
    display: block;
    margin-top: -10px;
    margin-right: 15px;
    background: #fff;
    white-space: nowrap;
}
.calendar-day-time-30 span {
    visibility: visible;
    display: block; /* inline-block; */
    margin-top: -6px;
    padding-right: 4px;
    font-size: 12px;
    line-height: 12px;
    color: #666;
    background-color: #fff;
    width: 75%;
    white-space: nowrap;
}
.calendar-day-time-15 span,
.calendar-day-time-45 span {
    visibility: visible;
    display: block; /* inline-block; */
    background-color: #fff;
    margin-top: -2px;
    height: 2px;
    width: 90%;
    overflow: hidden;
}

/* ROWS / COLUMNS */
/* .calendar-page-name {
    grid-row: row-page;
    grid-column: 1 / -1;
    font-weight: bold;
    border-bottom: 1px solid #ccc
} */
.calendar-row-title { 
    grid-row: row-title;
    background: none;
    font-weight: bold;
    text-align: center;
    white-space: nowrap;
    padding: 0 5px;
    overflow: hidden;
    text-overflow: ellipsis;
}
.calendar-row-title.col-availability {
    background-color: #fff;
}

.calendar-row-yesterday {
    grid-row: row-yesterday;
    grid-column: 1 / -1;
    /* background-color: #fff9; */
    background-color: var(--col-calendar-bg-light);
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
}
.calendar-row-tomorrow {
    grid-row: row-tomorrow;
    grid-column: 1 / -1;
    /* background-color: #fff; */
    background-color:  var(--col-calendar-bg-light);
    border-bottom: 1px solid #ccc;
}

.col-time {
    grid-column: col-time;
}
.col-availability {
    grid-column: col-slot;
}
.col-meeting {
    grid-column: col-meeting;
}
.col-notrack { grid-column: col-notrack; }
.col-track0 { grid-column: col-track0; }
.col-track1 { grid-column: col-track1; }
.col-track2 { grid-column: col-track2; }
.col-track3 { grid-column: col-track3; }
.col-track4 { grid-column: col-track4; }
.col-track5 { grid-column: col-track5; }
.col-track6 { grid-column: col-track6; }
.col-track7 { grid-column: col-track7; }
.col-track8 { grid-column: col-track8; }
.col-track9 { grid-column: col-track9; }
.col-track10 { grid-column: col-track10; }
.col-track11 { grid-column: col-track11; }
.col-track12 { grid-column: col-track12; }

.col-bg {
    background-color: #fff; /* #f0f0f0; */
    border: none;
    grid-row: row-title / -1;
}
.col-bg.col-availability {
    background-color: var(--col-calendar-bg-light);
    /* background-color: #333; */
}
/*
.col-bg.col-meeting {
    background-color: #fafafa;
} */

.calendar-day-empty {
    grid-row: 5 / 10;
    grid-column: 3 / -1;
    background-color: #ccc;
    display: grid;
    align-content: center;
    justify-content: center;
}
.calendar-day-anon .calendar-day-empty {
    grid-column: 1 / -1;
}
.calendar-day-empty span {
    color: #fff;
    font-weight: bold;
}

/* SLOTS */
.col-slot {
    margin: 0; /* 1px 0; */
}
/* .calendar-toggle-slot {
    margin: 0;
} */
.calendar-day-slot {
    /* background-color: inherit;  */
    /* #9c9; */
    /* border-top: none;  */
    /* 1px solid #fff; */
    /* border-top: 1px solid rgba(204,204,204,0.7); */
    /* border-bottom: 1px solid rgba(204,204,204,0.7); */
    border-top: 1px solid #999;
    border-bottom: 1px solid #999;
    margin-bottom: -1px;
}
.calendar-day-slot-busy {
    /* border-top: none;  */
    /* 1px solid #fff; */
    /* background-color: rgb(91, 183, 91); */
    background-color: #fff;
    color: #090;
}
/* Obsolete: Closed slots not included any more */
/*
.calendar-day-slot-closed { 
    background-color: #999;
}
*/
/* #calendar-day .calendar-slot-private { */
    /*
    background-color: transparent;
    color: #333; */
    /* z-index: 75; */
/* } */

/* CalendarItem customisation! */
#calendar-day .calendar-item {
    background: rgba(255,255,255,1);
    /*
    border-left: 0;
    border-right: 0;
    border-top: 1px solid rgba(204,204,204,0.7);
    border-bottom: 1px solid rgba(204,204,204,0.7);
    */
    border: 0;
    font-size: 12px;
    line-height: 16px;
    /*margin-bottom: -1px; */ /* Overlap consecutive borders to prevent thick lines */
    margin: 1px 0 1px; /* Tiny gap between items */
    min-width: 0; /* CRITICAL: PREVENT Appointment.abstract BREAKING LAYOUT */
    position: relative;
}
.meeting-colleague-count {
    position: absolute;
    top: 0;
    right: 0;
    margin: 3px;
    padding: 2px;
    border-radius: 3px;
    background: #6669;
    color: #fff;
    font-size: 10px;
    line-height: 10px;;
}
#calendar-day .calendar-item.calendar-item-pinned {
    background: rgba(255,255,255,0.9);
}

#calendar-day .calendar-schedule-status {
    margin: 4px 3px 0;
    align-self: auto;
}

#calendar-day .calendar-schedule-detail {
    padding-top: 4px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: normal;
}

/* NEW LAYOUT */
#calendar-day .calendar-item {
    display: flex;
    gap: 0 5px;
    padding: 2px;
    overflow: hidden;
}
#calendar-day .calendar-item.track-hidden {
    background-color: #333;
    color: #eee;
    align-items: center;
}
#calendar-day .calendar-item.track-hidden .calendar-item-time {
    display: none;
}
#calendar-day .calendar-item-title {
    font-weight: bold;
}
#calendar-day .calendar-item-name, 
#calendar-day .calendar-item-organisation-name {
    display: inline-block;
}
#calendar-day .calendar-item-name {
    margin-right: 5px;
}
#calendar-day .calendar-item-meta {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 0 10px;
}
#calendar-day .calendar-item-meta .calendar-item-time {
    width: fit-content;
    white-space: nowrap;
    xmargin-right: 10px;
}
#calendar-day .calendar-item-meta .calendar-item-location {
    flex-grow: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
}
#calendar-day .calendar-item-abstract {
    word-break: break-word;
}


/* Tidy up the abstracts a little bit */
.calendar-item-abstract p:last-child {
    margin-bottom: 0;
}

/* Icons */
#calendar-day .calendar-item .calendar-icon {
    min-width: 16px;
    width: 16px;
    height: 16px;
    margin: 2px 0 0 2px;
}


/* PINNED TAIL THEMES */
.calendar-day-pinned-tail {
    /* background-color: #ff00; */
    opacity: 0.5;
    border-top: none;
    margin: -1 0; /* Negative margins to make it wrap the Items better */
}
/*
.calendar-day-pinned-tail.track0 {
  background-color: #77AADD;
}
.calendar-day-pinned-tail.track-order,
.calendar-day-pinned-tail.track-order0 { /* Corner-cases for trackless Appointments * /
  background-color: #77AADD;
}
.calendar-day-pinned-tail.track-order1 {
  background-color: #99DDFF;
}
.calendar-day-pinned-tail.track-order2 {
  background-color: #44BB99;
}
.calendar-day-pinned-tail.track-order3 {
  background-color: #BBCC33;
}
.calendar-day-pinned-tail.track-order4 {
  background-color: #AAAA00;
}
.calendar-day-pinned-tail.track-order5 {
  background-color: #EEBB88;
}
.calendar-day-pinned-tail.track-order6 {
  background-color: #EE8866;
}
.calendar-day-pinned-tail.track-order7 {
  background-color: #FFAABB;
}
.calendar-day-pinned-tail.track-hidden {
  background-color: #000;
}
*/

/* COLOR THEMING */
#calendar-day .calendar-item {
    border-radius: 3px;
    margin-left: 2px;
    margin-right: 2px;
}

/* MEETINGS */
#calendar-day .calendar-item-meeting {
    color: var(--col-text-meeting);
}
#calendar-day .calendar-item-meeting-confirmed {
    background-color: var(--col-meeting-confirmed);
}
#calendar-day .calendar-item-meeting-inbound {
    background-color: var(--col-meeting-inbound);
}
#calendar-day .calendar-item-meeting-outbound {
    background-color: var(--col-meeting-outbound);
}

/* APPOINTMENTS */
#calendar-day .calendar-item-appointment {
    color: var(--col-text-appointment);
}
.calendar-day-pinned-tail.track-order0,
#calendar-day .calendar-item-appointment.track-order0 {
    background-color: var(--col-track0);
}
.calendar-day-pinned-tail.track-order1,
#calendar-day .calendar-item-appointment.track-order1 {
    background-color: var(--col-track1);
}
.calendar-day-pinned-tail.track-order2,
#calendar-day .calendar-item-appointment.track-order2 {
    background-color: var(--col-track2);
}
.calendar-day-pinned-tail.track-order3,
#calendar-day .calendar-item-appointment.track-order3 {
    background-color: var(--col-track3);
}
.calendar-day-pinned-tail.track-order4,
#calendar-day .calendar-item-appointment.track-order4 {
    background-color: var(--col-track4);
}
.calendar-day-pinned-tail.track-order5,
#calendar-day .calendar-item-appointment.track-order5 {
    background-color: var(--col-track5);
}
.calendar-day-pinned-tail.track-order6,
#calendar-day .calendar-item-appointment.track-order6 {
    background-color: var(--col-track6);
}
.calendar-day-pinned-tail.track-order7,
#calendar-day .calendar-item-appointment.track-order7 {
    background-color: var(--col-track7);
}
.calendar-day-pinned-tail.track-hidden,
#calendar-day .calendar-item-appointment.track-hidden {
    background-color: var(--col-track-hidden);
}

/* ICONS Reset to white/translucent */
#calendar-day .calendar-item-appointment .calendar-icon {
    color: var(--col-icon-inverse); /* #fff9; */
}
#calendar-day .calendar-item-meeting .calendar-icon,
#calendar-day .calendar-item-ticketed .calendar-icon,
#calendar-day .calendar-item-pinned .calendar-icon {
    color: var(--col-icon-inverse); /* #fff9; */
}




/* Z-INDEX Order 
Higher number = Item appear on top of lower numbers.

 50  .calendar-day-pinned-tail (Translucent backround that spans the columns underneath a Pinned Appointment)
 70  .calendar-day-slot (Default pale green background for an Availability Toggle)
 70  .calendar-day-slot-busy (Bold green 'Busy' slot)
 75  .calendar-slot-private (Slot that has been toggled to 'Private')
100  .calendar-item-appointment (Any Appointment)
125  .calendar-item-ticketed (Appointment I have a ticket for)
150  .calendar-item-meeting (Any Meeting)
*/
.calendar-row-yesterday,
.calendar-row-tomorrow {
    z-index: 25;
}
#calendar-day .calendar-day-pinned-tail {
    z-index: 50;
}
#calendar-day .calendar-day-slot {
    z-index: 70;
}
#calendar-day .calendar-day-slot-busy {
    z-index: 70;
}
#calendar-day .calendar-slot-private {
    z-index: 75;
}
#calendar-day .calendar-item-appointment {
    z-index: 100;
}
#calendar-day .calendar-item-ticketed {
    z-index: 125;
}
#calendar-day .calendar-item-meeting {
    z-index: 150;
}


/* PRINT CUSTOMISATIONS */
@media print {
    #calendar-day .calendar-toggle-slot {
        display: none;
    }
}
</style>